export default {
  '***': {
    '***': [
      {
        "id": 100,
        "label": "Insurance Types",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          101,
          102,
          103,
          104,
          105,
          106
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 101,
        "label": "Home/Renters",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Home or renters insurance products"
      },
      {
        "id": 102,
        "label": "Auto",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Auto insurance products"
      },
      {
        "id": 103,
        "label": "Bundle",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Bundled insurance products"
      },
      {
        "id": 104,
        "label": "RV",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "RV insurance products"
      },
      {
        "id": 105,
        "label": "Boat",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Boat insurance products"
      },
      {
        "id": 106,
        "label": "Motorcycle",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Motorcycle insurance products"
      },
      {
        "id": 200,
        "label": "Brand Image",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          201,
          202,
          203,
          204
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 201,
        "label": "Awards/Accolades",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "Refers to any reference of awards or rankings, 3rd party or commissioned research based."
      },
      {
        "id": 202,
        "label": "Customer Service",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "Refers to a primary focus on customer service"
      },
      {
        "id": 203,
        "label": "General Reputation",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "Refers to any ad that focuses on a brand's general reputation, but does not mention any products"
      },
      {
        "id": 204,
        "label": "Sponsorship",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 300,
        "label": "Creative Style",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          301,
          302,
          303,
          304,
          305,
          306
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 301,
        "label": "Humorous",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "The intent of the ad is to make you laugh. Formerly \"Contains Humor\" under \"other Ad Features\" for BE"
      },
      {
        "id": 302,
        "label": "Emotional",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "The intent of the ad is to elicit sad or heartwarming emotion"
      },
      {
        "id": 303,
        "label": "Family Focus (e.g. kids, families, etc.)",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Includes any ads focusing on families or children. Does not include couples only"
      },
      {
        "id": 304,
        "label": "Older Focus (e.g. older adults)",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Includes any ads with a particular focus on adults 60+"
      },
      {
        "id": 305,
        "label": "Diverse Audience Focus",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Ad has an intentional focus on people from multiple ethnic or cultural backgrounds"
      },
      {
        "id": 306,
        "label": "Branding in First 5 seconds",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "The advertising brand is shown or spoken in the first 5 seconds"
      },
      {
        "id": 400,
        "label": "Narrative Type",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          401,
          402,
          403,
          404
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 401,
        "label": "Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 400,
        "children": [],
        "tooltip": "Ad follows a story trajectory, even if short."
      },
      {
        "id": 402,
        "label": "Split Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 400,
        "children": [],
        "tooltip": "Ad features two or more distinct narrative threads interwoven or presented in parallel within the same ad. Each thread typically involves different characters, settings, or perspectives."
      },
      {
        "id": 403,
        "label": "Montage",
        "selected": 0,
        "collapse": 0,
        "parent": 400,
        "children": [],
        "tooltip": "series of disjointed scenes or scenes with unclear sequence of events (e.g. a narrative montage with huge gaps of time between scenes)"
      },
      {
        "id": 404,
        "label": "Non-Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 400,
        "children": [],
        "tooltip": "Ad does not feature narrative, usually focusing on a product with few or no actual filmed scenes"
      },
      {
        "id": 500,
        "label": "Music",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          501,
          502
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 501,
        "label": "Music Present Indicator",
        "selected": 0,
        "collapse": 0,
        "parent": 500,
        "children": [],
        "tooltip": "any and all"
      },
      {
        "id": 502,
        "label": "Popular Song",
        "selected": 0,
        "collapse": 0,
        "parent": 500,
        "children": [],
        "tooltip": "Refers to an identifiable song - either lyrics or instrumental. Formerly \"Creative Style\" in AdPi Coding"
      },
      {
        "id": 600,
        "label": "Personas Present",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          601,
          602,
          603,
          604
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 601,
        "label": "Celebrity",
        "selected": 0,
        "collapse": 0,
        "parent": 600,
        "children": [],
        "tooltip": "character introduced as celebrity or recongizable by coder - does not apply to celebrities playing characters unless their indenpendent fame is explicitly leveraged/referenced"
      },
      {
        "id": 602,
        "label": "Spokesperson",
        "selected": 0,
        "collapse": 0,
        "parent": 600,
        "children": [],
        "tooltip": "Includes both celebrity and non-celebrity spokespeople. Looking directly at camera"
      },
      {
        "id": 603,
        "label": "Brand Character",
        "selected": 0,
        "collapse": 0,
        "parent": 600,
        "children": [],
        "tooltip": "character or mascot exclusive to a particular brand"
      },
      {
        "id": 604,
        "label": "Company official/owner",
        "selected": 0,
        "collapse": 0,
        "parent": 600,
        "children": [],
        "tooltip": "character must be introduced as an actual official and not an actor"
      },
      {
        "id": 700,
        "label": "Narration",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          701,
          702
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 701,
        "label": "People on camera",
        "selected": 0,
        "collapse": 0,
        "parent": 700,
        "children": [],
        "tooltip": "character must be seen speaking"
      },
      {
        "id": 702,
        "label": "Voiceover narration",
        "selected": 0,
        "collapse": 0,
        "parent": 700,
        "children": [],
        "tooltip": "An off-screen narrator is featured."
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/app/configuration/FinancialServicesBanking/config/components/selection/Search/tagHierarchy.js